import FooterControl from '@/components/FooterControl.vue';
import MessageDialog from '@/components/MessageDialog.vue';
import E from 'wangeditor';
import config from '@/config/index';

export default {
  name: 'new-Information',
  components: { FooterControl, MessageDialog },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 24 * 1000;
        },
      },
      dialogImageUrl: '',
      dialogVisible: false,
      ruleForm: {
        messageHead: '', // 通知标题
        synopsis: '', // 通知简介
        pictureUrl: '',
        popWindow: 0, // 是否弹窗
      },
      rules: { // 表单校验规则
        messageHead: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        activeTime: [
          { required: true, message: '请选择上线时间', trigger: 'change' },
        ],
      },
      id: this.$route.query.id || '',
      models: this.$route.query.state || 'add',
      editor: null,
      info: null,
      msgShow: false,
      uploadUrl: `${config.host}/upload/oss/upload`, // 上传病历地址
      allowFileType: [
        'jpg',
        'jpeg',
        'png',
      ],
      msgType: 1, // 弹窗形式
      active: false,
    };
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    isClear: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear();
        this.info = null;
      }
    },
    value(val) {
      // 使用 v-model 时，设置初始值
      this.editor.txt.html(val);
    },
  },
  methods: {
    handleRemove() {
      this.ruleForm.pictureUrl = '';
    },
    handleAvatarSuccess(res, file) {
      const list = JSON.parse(file.response);
      [this.ruleForm.pictureUrl] = list.data;
    },
    beforeAvatarUpload(file) {
      // 判断文件后缀
      let fileType = '';
      if (file.fileType) {
        fileType = file.fileType.substring(file.fileType.indexOf('.') + 1);
      } else {
        fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
      }
      const isFile = this.allowFileType.includes(fileType);
      const isLt10M = file.size / 1024 / 1024 < 0.1;
      if (!isFile) {
        this.$message.error('上传图片只能是 JPG、PNG、JPEG 格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 100kb!');
      }
      return isFile && isLt10M;
    },
    goback() {
      this.$router.go(-1);
    },
    // 预览
    preview(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.msgShow = true;
        } else {
          return false;
        }
      });
    },
    // 删除
    delMsg() {
      this.$api.systemSet.delMessage({
        id: this.ruleForm.messageId,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功！',
        });
        this.goback();
      });
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 选择了文字弹窗
          if (this.msgType) {
            this.ruleForm.pictureUrl = '';
          }
          if (this.models === 'add') {
            this.$api.systemSet.generate({
              ...this.ruleForm,
              messageBody: this.editor.txt.html().toString(),
            }).then((res) => {
              console.log(res);
              this.$message({
                type: 'success',
                message: '新增资讯成功！',
              });
              this.goback();
            });
          } else {
            this.$api.systemSet.updateMessage({
              ...this.ruleForm,
              id: this.ruleForm.messageId,
              messageBody: this.editor.txt.html().toString(),
            }).then(() => {
              this.$message({
                type: 'success',
                message: '修改资讯成功！',
              });
              this.goback();
            });
          }
        } else {
          return false;
        }
      });
    },
    getMsgDetail() {
      if (this.$route.query.state === 'edit') {
        this.$api.systemSet.getMessageDetail({
          id: this.id,
        }).then((res) => {
          this.ruleForm = res;
          if (res.pictureUrl) {
            this.msgType = 0;
          }
          if (res.popWindow) {
            this.ruleForm.popWindow = true;
          }
          this.editor.txt.html(res.messageBody);
          console.log(res);
        });
      }
    },
    seteditor() {
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      this.editor.customConfig.uploadImgShowBase64 = true; // base 64 存储图片
      // this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
      // this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      // this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      // 配置菜单
      this.editor.customConfig.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'table', // 表格
        'video', // 插入视频
        'code', // 插入代码
        'undo', // 撤销
        'redo', // 重复
      ];
      this.editor.customConfig.onchange = (html) => {
        this.info = html; // 绑定当前值
        this.$emit('change', this.info); // 将内容同步到父组件中
      };
      // 创建富文本编辑器
      this.editor.create();
    },
  },
  mounted() {
    this.seteditor();
    this.getMsgDetail();
  },
  computed: {
  },
};
